import { render } from "./Ehrenamt.vue?vue&type=template&id=08a279ed"
import script from "./Ehrenamt.vue?vue&type=script&lang=js"
export * from "./Ehrenamt.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__